module.exports = {
  "scaleTemplate": {
    "scaleTemplate": "量表模板",
    "scaleList": "量表列表",
    "scaleName": "量表名称",
    "scaleNameHint": "请输入量表名称",
    "scaleType": "量表类型",
    "scaleTypeHint": "请输入量表类型用逗号隔开",
    "scaleTypeHint2": "请选择量表类型",
    "scaleID": "量表ID",
    "applicableObjects": "适用对象",
    "applicableObjectsHint": "请输入适用对象",
    "usageTime": "用时（分）",
    "usageTimeHint": "请输入用时",
    "questionsNumber": "题数",
    "scaleEvaluationRecords": "量表测评记录",
    "editQuestionBank": "编辑题库",
    "initiateEvaluation": "发起测评",
    "deleteScalelHint": "删除该量表 {0} 将不可恢复，确定吗？",
    "addScale": "添加量表",
    "editScale": "编辑量表",
    "viewScale": "查看量表",
    "scaleInfo": "量表信息",
    "scaleDescription": "量表说明",
    "scaleDescriptionHint": "请输入量表说明",
    "scalePic": "量表图片",
    "reportTemplate": "报告模板",
    "reportTemplateHint": "请选择报告模板",
    "modificationArea": "修改区",
    "inspectionArea": "检查区",
    "questionBankHint": "可在此区域按规则手动添加、编辑题目;也可批量导入题目",
    "questionBankHint2": "此区域将检查导入的题目是否符合规则",
    "questionBankSureErrorHint": "检查区内含有没有解决的错误提示，请核对完成后再保存",
    "questionBankSureErrorHint2": "题目数量不能为0",
    "questionBankErrorHint": "单选题的选项不能少于2个",
    "questionBankErrorHint2": "多选题的选项不能少于3个",
    "questionBankErrorHint3": "选项不能为空",
    "questionBankErrorHint4": "题目不能为空",
    "questionBankErrorHint5": "请给选项设置一个分数",
    "reportingRules": "报告规则",
    "reportingRulesHint": "请完善报告规则",
    "reportingRulesHint2": '标签 "{0}" 设置的分数范围有冲突，请重新输入',
    "reportingRulesHint3": '分组 "{0}" 设置的分数范围有冲突，请重新输入',
    "reportingRulesHint4": '题目 "{0}" 设置的分数范围有冲突，请重新输入',
    "reportingRulesHint5": '总分设置的分数范围有冲突，请重新输入',
    "reportingRulesHint6": '请先添加报告规则后再执行此操作',
    "warningRules": "预警规则",
    "warningRulesHint": "请先完善报告规则后再填写预警规则",
    "label": "标签",
    "selectLabel": "选择标签",
    "selectLabelHint": "请选择一个标签",
    "scoringMethod": "计分方式",
    "scoringMethodHint": "请完善计分方式",
    "totalScore": "总分",
    "averageScore": "平均分",
    "riskLevel": "预警等级",
    "scoreRange": "得分范围",
    "evaluationResults": "评定结果",
    "evaluationResultsHint": "请输入评定结果",
    "resultDescription": "结果描述",
    "resultDescriptionHint": "请输入结果描述",
    "interventionPlan": "干预方案",
    "interventionPlanHint": "请输入干预方案",
    "crisisIssues": "危机问题",
    "reviewScale": "复查量表",
    "reviewScaleHint": "请选择复查量表",
    "jumpRules": "跳转规则",
    "atmxxpd": "按题目选项判断",
    "atmdfpd": "按题目得分判断",
    "assignedTopics": "指定题目",
    "specifyOptions": "指定选项",
    "judgmentRules": "判断规则",
    "judgmentRulesOption1": "指定题目的指定选项有任意一个完全匹配",
    "judgmentRulesOption2": "指定题目的指定选项完全匹配",
    "judgmentRulesOption3": "指定题目的指定选项都不匹配",
    "judgmentRulesOption4": "指定题目的分数有任意一个完全匹配",
    "judgmentRulesOption5": "指定题目的分数完全匹配",
    "judgmentRulesOption6": "指定题目的分数都不匹配",
    "judgmentRulesOption7": "大于",
    "judgmentRulesOption8": "小于",
    "judgmentRulesOption9": "等于",
    "judgmentRulesOption10": "大于等于",
    "judgmentRulesOption11": "小于等于",
    "judgmentRulesOption12": "不等于",
    "jumpingQuestion": "跳转后的题目",
    "jumpingQuestionHint": "一条规则内跳转后的题目不能和指定题目相同",
    "emptyHint": "清空跳转规则将不可恢复，确定吗？",
    "score": "分",
    "score2": "分数",
    "score2Hint": "请输入分数",
    "saveErrorHint": "请完善跳转规则",
    "isEndEvaluation": "是否结束测评",
    "interval": "区间",
    "evaluateLogicalRules": "评估逻辑规则",
    "judgingByRules": "按规则判断",
    "specifyRules": "指定规则",
    "rule": "规则",
    "evaluateResults": "评估结果",
    "evaluateResultsHint": "请输入评估结果",
    "count": "计数",
    "give": "且",
    "or": "或",
    "maxRankError": "评估逻辑规则层级最多支持{0}级",
    "testContent": "测评内容",
    "testDesc": "测评结果说明",
    "ruleName": "规则名称",
    "ruleNameHint": "请输入规则名称",
    "reviewLabel": "复查因子",
    "reviewLabelHint": "请选择复查因子",
    "scoreLookupTable": "标准化分数查表",
    "scoreLookupTableList": "标准化分数查表列表",
    "pleaseSelectThescalefactor": "请选择量表因子",
    "factor": "因子",
    "factorScoring": "因子计分",
    "factorScoringHint": "请输入因子计分",
    "factorScoringHint2": "请输入正确的因子计分",
    "standardizedScore": "标准化分数",
    "standardizedScoreHint": "请输入标准化分数",
    "standardizedScoreHint2": "请输入正确的标准化分数",
    "guide": "引导语",
    "guideHint": "请输入引导语",
    "scaleSource": "量表出处",
    "scaleSourceHint": "请输入量表出处",
    isWarning: "是否预警",
    copyScale: "复制量表",
    copyScaleHint: "量表复制成功",
    "isSummary": "综合测评结果开关",
    testIntro: "测试说明",
    testIntroHint: "请输入测试说明",
    isClinical: "临床量表"
  },
};



// WEBPACK FOOTER //
// ./src/i18n/scaleTemplate/zh-CN.js